import { useState } from "react"

// Poll Component
const PollComponent = ({ poll }) => {
    const [selectedOption, setSelectedOption] = useState(null)
    const totalVotes = poll.options.reduce((sum, opt) => sum + opt.votes, 0)

    return (
        <div className="bg-gradient-to-br from-blue-50 to-purple-50 rounded-xl p-5 mb-4">
            <h3 className="font-semibold text-gray-900 mb-4 flex items-center gap-2">
                <span className="text-lg">📊</span>
                {poll.question}
            </h3>
            <div className="space-y-3">
                {poll.options.map((option, index) => {
                    const percentage = totalVotes > 0 ? (option.votes / totalVotes * 100).toFixed(1) : 0
                    return (
                        <div key={option._id} className="relative">
                            <button
                                onClick={() => setSelectedOption(index)}
                                className={`w-full text-left px-4 py-3 rounded-lg border-2 transition-all ${
                                    selectedOption === index
                                        ? 'border-blue-500 bg-blue-50'
                                        : 'border-gray-200 bg-white hover:border-blue-300'
                                }`}
                            >
                                <div className="flex justify-between items-center">
                                    <span className="text-sm font-medium text-gray-700">{option.text}</span>
                                    <span className="text-xs font-semibold text-gray-500">{percentage}%</span>
                                </div>
                                {totalVotes > 0 && (
                                    <div className="mt-2 h-2 bg-gray-200 rounded-full overflow-hidden">
                                        <div 
                                            className="h-full bg-blue-500 transition-all duration-500"
                                            style={{ width: `${percentage}%` }}
                                        />
                                    </div>
                                )}
                            </button>
                        </div>
                    )
                })}
            </div>
            <p className="text-xs text-gray-500 mt-3 text-center">
                {totalVotes} {totalVotes === 1 ? 'vote' : 'votes'}
            </p>
        </div>
    )
}

export default PollComponent;